class PaymentInfo {
  constructor(data) {
    this.id = data.id;
    this.cardBrand = data.cardBrand
    this.cardNumber = data.cardNumber
    this.cardExpiration = data.expirationDate
    this.cardHolderName = data.cardholderName
    this.isDefault = data.isDefault
    this.paymentMethodToken = data.paymentMethodToken

    this.billingAddress = ''
    this.country = ''
    this.city = ''
    this.state = ''
    this.phoneNumber = ''
  }
}
export default PaymentInfo
